import styleClasses from '../css/mobile/MusicardPopup.module.scss';

const MusicardPopup = ({ setModalOpen, element, closeStyle }) => {
    const backDetail = () => {
        setModalOpen(false);
    };

    return (
        <>
            <div className={ styleClasses.popupBackdrop } onClick={ backDetail }></div>
            <div className={ styleClasses.popupMobile }>
                <div className={ styleClasses.inner }>
                    <div className={` ${ styleClasses.close } ${ styleClasses[closeStyle] }`} onClick={ backDetail }>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                            <path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path>
                        </svg>
                    </div>
                    { element }
                </div>
            </div>
        </>
    )
}

export default MusicardPopup;